import { useEffect, useState } from "react";
import { Menu, LogOut, X } from "lucide-react";

export const LOGOUT_CONFIRM = "Yakin ingin keluar?";

// Menu akun ☰ (HP): nama akun + aksi tambahan + Keluar dengan konfirmasi.
export function AccountMenu({ name, role, onLogout, children }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!e.target.closest(".acct-menu")) setOpen(false); };
    const esc = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", esc); };
  }, [open]);
  const doLogout = () => { setOpen(false); if (window.confirm(LOGOUT_CONFIRM)) onLogout(); };
  return <div className="acct-menu" data-testid="account-menu">
    <button type="button" className="acct-menu-btn" aria-label="Menu akun" aria-expanded={open}
      onClick={() => setOpen(v => !v)} data-testid="account-menu-btn">{open ? <X size={20}/> : <Menu size={20}/>}</button>
    {open && <div className="acct-menu-panel" role="menu" data-testid="account-menu-panel">
      <div className="acct-menu-who">
        <small>Masuk sebagai</small>
        <strong data-testid="account-menu-name">{name}</strong>
        {role && <span data-testid="account-menu-role">{role}</span>}
      </div>
      {children && <div className="acct-menu-items" onClick={() => setOpen(false)}>{children}</div>}
      <button type="button" role="menuitem" className="acct-menu-logout" onClick={doLogout} data-testid="account-menu-logout">
        <LogOut size={16}/> Keluar
      </button>
    </div>}
  </div>;
}
